import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import "./AjusteBeneficiario.css";

function AjusteBeneficiario() {
  const { id } = useParams();
  const location = useLocation();
  const { pessoas } = location.state || { pessoas: [] };

  const [dadosEditados, setDadosEditados] = useState(pessoas);
  const [anexos, setAnexos] = useState({});
  const [enviado, setEnviado] = useState(false);
  const [bloqueado, setBloqueado] = useState(false);

  useEffect(() => {
    fetch(`https://gerencial.vionia.com.br/api/ajuste/${id}`)
      .then(res => res.json())
      .then(data => {
        const todosEstaoNoEstagio5 = data.pessoas.every(p => p.estagio === 5);
        if (!todosEstaoNoEstagio5) {
          setBloqueado(true);
        }
      })
      .catch(err => {
        console.error("Erro ao verificar estágio:", err);
      });
  }, [id]);

  const handleInputChange = (index, campo, valor) => {
    const novosDados = [...dadosEditados];
    novosDados[index][campo] = valor;
    setDadosEditados(novosDados);
  };

  const handleArquivoChange = (idPessoa, files) => {
    setAnexos(prev => ({ ...prev, [idPessoa]: files }));
  };

  const handleSalvar = async () => {
  try {
    const res = await fetch("https://gerencial.vionia.com.br/api/ajuste/salvar", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pessoas: dadosEditados }),
    });

    if (!res.ok) {
      const erro = await res.json();
      if (erro.detail?.includes("Proposta já foi ajustada")) {
        setBloqueado(true);
        alert("Essa proposta já foi ajustada. Novos envios não são permitidos.");
        return;
      }
      throw new Error(erro.detail || "Erro ao salvar.");
    }

    for (const idPessoa in anexos) {
      const formData = new FormData();
      for (let file of anexos[idPessoa]) {
        formData.append("arquivo", file);
      }

      await fetch(`https://gerencial.vionia.com.br/api/ajuste/upload/${idPessoa}`, {
        method: "POST",
        body: formData,
      });
    }

    alert("Dados e anexos enviados com sucesso!");
    setEnviado(true);
    setBloqueado(true); // ← trava a tela após envio
  } catch (err) {
    console.error("Erro ao salvar:", err);
    alert("Erro ao salvar. Tente novamente.");
  }
};


  return (
    <div className="ajuste-container">
      <h2 className="ajuste-titulo">Ajuste de Proposta</h2>

      {dadosEditados.map((pessoa, index) => (
        <div key={pessoa.id} className="ajuste-card">
          <h3 className="ajuste-subtitulo">{index === 0 ? "Titular" : `Dependente ${index}`}</h3>
          <div className="input-group">

            <div className="input-field">
              <label>Nome completo</label>
              <input value={pessoa.nome} onChange={e => handleInputChange(index, "nome", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>CPF</label>
              <input value={pessoa.cpf} onChange={e => handleInputChange(index, "cpf", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Data de Nascimento</label>
              <input type="date" value={formatarParaInputDate(pessoa.data_nascimento)} onChange={e => handleInputChange(index, "data_nascimento", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Nome da mãe</label>
              <input value={pessoa.nome_mae || ""} onChange={e => handleInputChange(index, "nome_mae", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Email</label>
              <input value={pessoa.email || ""} onChange={e => handleInputChange(index, "email", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Celular</label>
              <input value={pessoa.celular || ""} onChange={e => handleInputChange(index, "celular", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Telefone</label>
              <input value={pessoa.telefone || ""} onChange={e => handleInputChange(index, "telefone", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>CEP</label>
              <input value={pessoa.cep || ""} onChange={e => handleInputChange(index, "cep", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Endereço</label>
              <input value={pessoa.rua || ""} onChange={e => handleInputChange(index, "rua", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Número</label>
              <input value={pessoa.numero || ""} onChange={e => handleInputChange(index, "numero", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Complemento</label>
              <input value={pessoa.complemento || ""} onChange={e => handleInputChange(index, "complemento", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Bairro</label>
              <input value={pessoa.bairro || ""} onChange={e => handleInputChange(index, "bairro", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Cidade</label>
              <input value={pessoa.cidade || ""} onChange={e => handleInputChange(index, "cidade", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>UF</label>
              <input value={pessoa.estado || ""} onChange={e => handleInputChange(index, "estado", e.target.value)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Peso (kg)</label>
              <input type="number" value={pessoa.peso || ""} onChange={e => handleInputChange(index, "peso", parseFloat(e.target.value) || 0)} disabled={bloqueado} />
            </div>

            <div className="input-field">
              <label>Altura (cm)</label>
              <input type="number" value={pessoa.altura || ""} onChange={e => handleInputChange(index, "altura", parseFloat(e.target.value) || 0)} disabled={bloqueado} />
            </div>

            <div className="input-field full-width">
              <label>Anexos (opcional)</label>
              <input type="file" multiple onChange={e => handleArquivoChange(pessoa.id, e.target.files)} disabled={bloqueado} />
            </div>

          </div>
        </div>
      ))}

      {!enviado && !bloqueado && (
        <button onClick={handleSalvar} className="botao-enviar">
          Enviar Ajustes
        </button>
      )}

      {bloqueado && (
        <p className="ajuste-bloqueado-msg">
          Essa proposta já foi ajustada. Novos envios não são permitidos.
        </p>
      )}
    </div>
  );
}

function formatarParaInputDate(dataStr) {
  if (!dataStr || dataStr.length !== 8) return "";
  const dia = dataStr.substring(0, 2);
  const mes = dataStr.substring(2, 4);
  const ano = dataStr.substring(4);
  return `${ano}-${mes}-${dia}`;
}

export default AjusteBeneficiario;
